import React from "react";
import {Route, Routes} from "react-router-dom"
import "./styles/base.css"
import "./styles/themes.css"
import Main from "./pages/Main/Main"
import Projects from "./pages/Projects/Projects"
import CV from "./pages/CV/CV";
import NotFound from "./pages/NotFound/NotFound"

function App() {
    return (
        <Routes>
            <Route path="/" element={<Main/>}/>
            <Route path="/projects" element={<Projects/>}/>
            <Route path="/cv" element={<CV/>}/>
            <Route path="/*" element={<NotFound/>}/>
        </Routes>
    )
}

export default App;
